import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export class CubiqResolver {
  public javaToJavaScriptType: Map<string, string> = new Map<string, string>();
  public javaToTypeScriptEnum: Map<string, string> = new Map<string, string>();

  // handled by DefaultBaseObjectEncoderImpl
  public encodedTypes: Set<string> = new Set<string>([
    // java primitivies
    "boolean",
    "double",
    "float",
    "int",
    "long",
    "short",
    // java objects
    "java.lang.Boolean",
    "java.lang.Double",
    "java.lang.Float",
    "java.lang.Integer",
    "java.lang.Long",
    "java.lang.Number",
    "java.lang.String",
    "java.math.BigDecimal",
    "java.util.Calendar",
    "java.util.Date",
    // valid, missing an encoder, allowed to fallthrough as a string
    "com.bcdfx.model.Message",
    "com.bcdfx.model.MessageImpl",
  ]);

  constructor() {
    this.javaToTypeScriptEnum.set(
      "com.bcdfx.model.InterventionEventCapability",
      "InterventionEventCapability",
    );
    this.javaToTypeScriptEnum.set("com.bcdfx.model.query.Operator", "Operator");
    this.javaToTypeScriptEnum.set(
      "com.bcdfx.api.servicerequest.reporting.StrategyQueryFetch",
      "StrategyQueryFetch",
    );
    this.javaToTypeScriptEnum.set("com.bcdfx.model.SystemControlStatus", "SystemControlStatus");
    this.javaToTypeScriptEnum.set(
      "com.bcdfx.model.ApplicationNotificationEventType",
      "ApplicationNotificationEventType",
    );
    this.javaToTypeScriptEnum.set(
      "com.bcdfx.model.common.api.enums.AllocationType",
      "AllocationType",
    );
    this.javaToTypeScriptEnum.set("com.bcdfx.model.ExecutionType", "ExecutionType");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.BenchmarkOrderType", "BenchmarkOrderType");
    this.javaToTypeScriptEnum.set("com.bcdfx.api.event.RejectSubType", "RejectSubType");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.TradeActionType", "TradeActionType");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.InterventionEventType", "InterventionEventType");
    this.javaToTypeScriptEnum.set(
      "com.bcdfx.model.common.api.enums.AlgoLimitPrice",
      "AlgoLimitPrice",
    );
    this.javaToTypeScriptEnum.set("com.bcdfx.model.FixingState", "FixingState");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.NdfHorizon", "NdfHorizon");
    this.javaToTypeScriptEnum.set(
      "com.bcdfx.api.servicerequest.reporting.OrderQueryFetch",
      "OrderQueryFetch",
    );
    this.javaToTypeScriptEnum.set("com.bcdfx.model.CreditType", "CreditType");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.PositionLevelState", "PositionLevelState");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.TransferStatus", "TransferStatus");
    this.javaToTypeScriptEnum.set(
      "com.bcdfx.servicerequest.dataprofile.DataProfileType",
      "DataProfileType",
    );
    this.javaToTypeScriptEnum.set("com.bcdfx.model.OrderIntent", "OrderIntent");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.Protocol", "Protocol");
    this.javaToTypeScriptEnum.set(
      "com.bcdfx.api.event.FxLifeCycleEventType",
      "FxLifeCycleEventType",
    );
    this.javaToTypeScriptEnum.set("com.bcdfx.model.FillRequestType", "FillRequestType");
    this.javaToTypeScriptEnum.set(
      "com.bcdfx.api.servicerequest.trading.AcceptanceAction",
      "AcceptanceAction",
    );
    this.javaToTypeScriptEnum.set(
      "com.bcdfx.model.InflightInclusionState",
      "InflightInclusionState",
    );
    this.javaToTypeScriptEnum.set("com.bcdfx.api.broker.ResponseCode", "ResponseCode");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.query.Condition", "Condition");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.FillState", "FillState");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.RoundToMillionsType", "RoundToMillionsType");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.Tenor", "Tenor");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.RateSideType", "RateSideType");
    this.javaToTypeScriptEnum.set(
      "com.bcdfx.monitor.api.OrderMonitorClusterMessage.RemoteMethod",
      "RemoteMethod",
    );
    this.javaToTypeScriptEnum.set("com.bcdfx.model.NotificationMethod", "NotificationMethod");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.InflightRuleType", "InflightRuleType");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.XferType", "XferType");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.RevaluationStatus", "RevaluationStatus");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.SystemControlType", "SystemControlType");
    this.javaToTypeScriptEnum.set("com.bcdfx.service.messaging.api.ChannelType", "ChannelType");
    this.javaToTypeScriptEnum.set(
      "com.bcdfx.api.servicerequest.market.MarketDataRequest.ActionType",
      "ActionType",
    );
    this.javaToTypeScriptEnum.set("com.bcdfx.model.PauseState", "PauseState");
    this.javaToTypeScriptEnum.set("com.bcdfx.streaming.EventType", "EventType");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.TriggerLogicType", "TriggerLogicType");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.CreditStatus", "CreditStatus");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.FillStpType", "FillStpType");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.OrderDealState", "OrderDealState");
    this.javaToTypeScriptEnum.set(
      "com.bcdfx.api.servicerequest.ManualNettingAction",
      "ManualNettingAction",
    );
    this.javaToTypeScriptEnum.set("com.bcdfx.model.OpsExceptionState", "OpsExceptionState");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.TimeComparison", "TimeComparison");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.DIReason", "DIReason");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.PositionOrderType", "PositionOrderType");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.BlotterType", "BlotterType");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.enums.AggregationType", "AggregationType");
    this.javaToTypeScriptEnum.set(
      "com.bcdfx.model.common.api.enums.HedgingModeType",
      "HedgingModeType",
    );
    this.javaToTypeScriptEnum.set("com.bcdfx.model.LockType", "LockType");
    this.javaToTypeScriptEnum.set(
      "com.bcdfx.api.servicerequest.sales.SalesApprovalAction",
      "SalesApprovalAction",
    );
    this.javaToTypeScriptEnum.set("com.bcdfx.model.DealUpdateTypeId", "DealUpdateTypeId");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.OrderType", "OrderType");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.InflightActionType", "InflightActionType");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.OrderStateFilter", "OrderStateFilter");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.OpsExceptionType", "OpsExceptionType");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.event.admin.ModelUpdateType", "ModelUpdateType");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.Product", "Product");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.UnitType", "UnitType");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.AccountBookingType", "AccountBookingType");
    this.javaToTypeScriptEnum.set(
      "com.bcdfx.model.MarketTimeConstantType",
      "MarketTimeConstantType",
    );
    this.javaToTypeScriptEnum.set(
      "com.bcdfx.model.common.api.enums.TermBaseEntry",
      "TermBaseEntry",
    );
    this.javaToTypeScriptEnum.set("com.bcdfx.model.OpsIntAction", "OpsIntAction");
    this.javaToTypeScriptEnum.set(
      "com.bcdfx.api.servicerequest.trading.PauseResumeAction",
      "PauseResumeAction",
    );
    this.javaToTypeScriptEnum.set("com.bcdfx.model.StrategyType", "StrategyType");
    this.javaToTypeScriptEnum.set(
      "com.bcdfx.api.servicerequest.trading.AcceptanceType",
      "AcceptanceType",
    );
    this.javaToTypeScriptEnum.set(
      "com.bcdfx.api.servicerequest.AdminImportType",
      "AdminImportType",
    );
    this.javaToTypeScriptEnum.set(
      "com.bcdfx.model.common.api.enums.AdminImportValidation",
      "AdminImportValidation",
    );
    this.javaToTypeScriptEnum.set(
      "com.bcdfx.model.common.api.enums.AdminModelOperationType",
      "AdminModelOperationType",
    );
    this.javaToTypeScriptEnum.set("com.bcdfx.model.enums.FwdRollRowType", "FwdRollRowType");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.FillStpRequirement", "FillStpRequirement");
    this.javaToTypeScriptEnum.set("com.bcdfx.api.servicerequest.trading.XferAction", "XferAction");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.MarkUpType", "MarkUpType");
    this.javaToTypeScriptEnum.set(
      "com.bcdfx.api.event.LifeCycleEventResponse.ResponseType",
      "ResponseType",
    );
    this.javaToTypeScriptEnum.set(
      "com.bcdfx.model.InterventionOperationType",
      "InterventionOperationType",
    );
    this.javaToTypeScriptEnum.set("com.bcdfx.model.SystemControlSubType", "SystemControlSubType");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.VisibilityProfileType", "VisibilityProfileType");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.ForwardPricingType", "ForwardPricingType");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.Precision", "Precision");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.OperatorComparison", "OperatorComparison");
    this.javaToTypeScriptEnum.set("com.bcdfx.streaming.ControlEventType", "ControlEventType");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.FixingFillType", "FixingFillType");
    this.javaToTypeScriptEnum.set("com.bcdfx.api.model.OrderState", "OrderState");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.AssetClass", "AssetClass");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.RequestOrderType", "RequestOrderType");
    this.javaToTypeScriptEnum.set(
      "com.bcdfx.model.fwdroll.FwdRollUpdateOperation",
      "FwdRollUpdateOperation",
    );
    this.javaToTypeScriptEnum.set("com.bcdfx.model.PositionUnit", "PositionUnit");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.UserType", "UserType");

    this.javaToJavaScriptType.set("com.bcdfx.model.AccountImpl", "AccountImpl");
    this.javaToJavaScriptType.set("com.bcdfx.model.ActivationDetailsImpl", "ActivationDetailsImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.AdjustedTenorForHolidayEventImpl",
      "AdjustedTenorForHolidayEventImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.admin.AdminArbitraryRequestImpl",
      "AdminArbitraryRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.AdminChangeUserPwdRequestImpl",
      "AdminChangeUserPwdRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.admin.AdminCreateUpdateRequestImpl",
      "AdminCreateUpdateRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.admin.AdminDeleteRequestImpl",
      "AdminDeleteRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.admin.AdminDetailedEntityReqImpl",
      "AdminDetailedEntityReqImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.admin.AdminEnumRequestImpl",
      "AdminEnumRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.AdminImportRequestImpl",
      "AdminImportRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.admin.AdminListingRequestImpl",
      "AdminListingRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.admin.AdminModelUpdateImpl",
      "AdminModelUpdateImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.AlgoHedgeConfigInfoImpl",
      "AlgoHedgeConfigInfoImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.AlgoStrategyImpl", "AlgoStrategyImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.fx.AllocationDataImpl",
      "AllocationDataImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.AllocationRequestDataImpl",
      "AllocationRequestDataImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.AmendMarkupLockRequestImpl",
      "AmendMarkupLockRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.AmendMarkupSalesApprovalRequestImpl",
      "AmendMarkupSalesApprovalRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.ApplicationMessageEventImpl",
      "ApplicationMessageEventImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.ApplicationNotificationFetchDescriptorImpl",
      "ApplicationNotificationFetchDescriptorImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.ApplicationNotificationsFetchRequestImpl",
      "ApplicationNotificationsFetchRequestImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.servicerequest.AuthRequestImpl", "AuthRequestImpl");
    this.javaToJavaScriptType.set("com.bcdfx.security.AuthResponseImpl", "AuthResponseImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.AutoHedgingChangeStateRequestImpl",
      "AutoHedgingChangeStateRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.AutoHedgingStatusEventImpl",
      "AutoHedgingStatusEventImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.AutoHedgingStatusImpl", "AutoHedgingStatusImpl");
    this.javaToJavaScriptType.set("com.bcdfx.model.BMTimeCodeImpl", "BMTimeCodeImpl");
    this.javaToJavaScriptType.set("com.bcdfx.model.fwdroll.BaseFwdRollData", "BaseFwdRollData");
    this.javaToJavaScriptType.set("com.bcdfx.security.BaseUserToken", "BaseUserToken");
    this.javaToJavaScriptType.set(
      "com.bcdfx.streaming.impl.BenchmarkCrossMarketRateImpl",
      "BenchmarkCrossMarketRateImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.streaming.impl.BenchmarkFeedEventImpl",
      "BenchmarkFeedEventImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.BenchmarkFixingImpl", "BenchmarkFixingImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.BenchmarkFixingRuleImpl",
      "BenchmarkFixingRuleImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.BenchmarkLockLifeCycleEventImpl",
      "BenchmarkLockLifeCycleEventImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.BenchmarkOrderRequestDataImpl",
      "BenchmarkOrderRequestDataImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.BenchmarkOrderRequestImpl",
      "BenchmarkOrderRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.BenchmarkPairConfigImpl",
      "BenchmarkPairConfigImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.audit.BenchmarkPositionAuditImpl",
      "BenchmarkPositionAuditImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.benchmarks.model.BenchmarkVisibilityPairAndOwnerImpl",
      "BenchmarkVisibilityPairAndOwnerImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.BigDecimalComparitorImpl",
      "BigDecimalComparitorImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.BlotterDefinitionDeleteRequestImpl",
      "BlotterDefinitionDeleteRequestImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.BlotterDefinitionImpl", "BlotterDefinitionImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.BlotterDefinitionListRequestImpl",
      "BlotterDefinitionListRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.BlotterDefinitionRequestImpl",
      "BlotterDefinitionRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.BlotterFilterDeleteRequestImpl",
      "BlotterFilterDeleteRequestImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.BlotterFilterImpl", "BlotterFilterImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.BlotterFilterListRequestImpl",
      "BlotterFilterListRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.BlotterFilterRequestImpl",
      "BlotterFilterRequestImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.BranchImpl", "BranchImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.BroadcastMessEventImpl",
      "BroadcastMessEventImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.BroadcastRequestImpl",
      "BroadcastRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.BulkAdminModelRequestImpl",
      "BulkAdminModelRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.BulkMarketDataRequestImpl",
      "BulkMarketDataRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.BulkOrderLifeCycleEventImpl",
      "BulkOrderLifeCycleEventImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.BulkOrderRequestImpl",
      "BulkOrderRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.CalculateMarkupRequestImpl",
      "CalculateMarkupRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.ChangeHedgingModeEventImpl",
      "ChangeHedgingModeEventImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.ChangePositionHedgingTypeRequestImpl",
      "ChangePositionHedgingTypeRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.ChangePositionHedgingTypeResponseImpl",
      "ChangePositionHedgingTypeResponseImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.ChangePositionHedgingTypeUpdateImpl",
      "ChangePositionHedgingTypeUpdateImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.service.messaging.impl.ChannelFilterImpl",
      "ChannelFilterImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.service.messaging.impl.ChannelMessageImpl",
      "ChannelMessageImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.messaging.server.ClientConnectorPingImpl",
      "ClientConnectorPingImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.ClientContactDeleteRequestImpl",
      "ClientContactDeleteRequestImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.ClientContactImpl", "ClientContactImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.ClientContactUpdateRequestImpl",
      "ClientContactUpdateRequestImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.ClientImpl", "ClientImpl");
    this.javaToJavaScriptType.set("com.bcdfx.model.ClientSettingImpl", "ClientSettingImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.ClientTraderDeleteRequestImpl",
      "ClientTraderDeleteRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.ClientTraderUpdateRequestImpl",
      "ClientTraderUpdateRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.service.messaging.impl.ConsumerChannelImpl",
      "ConsumerChannelImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.streaming.ControlItemImpl", "ControlItemImpl");
    this.javaToJavaScriptType.set("com.bcdfx.streaming.ControllEventImpl", "ControllEventImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.fx.CounterPartyDetailsImpl",
      "CounterPartyDetailsImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.CredentialChangeEventImpl",
      "CredentialChangeEventImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.fx.CreditRevalDetailsImpl",
      "CreditRevalDetailsImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.streaming.CrossMarketRateImpl", "CrossMarketRateImpl");
    this.javaToJavaScriptType.set("com.bcdfx.model.CurrencyImpl", "CurrencyImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.calendar.CurrencyPairCalendarImpl",
      "CurrencyPairCalendarImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.CurrencyPairGroupImpl", "CurrencyPairGroupImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.CurrencyPairGroupMemberImpl",
      "CurrencyPairGroupMemberImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.CurrencyPairImpl", "CurrencyPairImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.CustomFieldImpl",
      "CustomFieldImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.CustomValueImpl",
      "CustomValueImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.DIRequestItemImpl", "DIRequestItemImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.DataProfileDescriptorImpl",
      "DataProfileDescriptorImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.DataProfileRequestImpl",
      "DataProfileRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.DataProfileResponseImpl",
      "DataProfileResponseImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.DateComparitorImpl", "DateComparitorImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.DateTimeComparitorImpl",
      "DateTimeComparitorImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.DealComponentDetailsImpl",
      "DealComponentDetailsImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.DealConfirmationImpl", "DealConfirmationImpl");
    this.javaToJavaScriptType.set("com.bcdfx.model.DealImpl", "DealImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.DefaultAccountProfileMappingImpl",
      "DefaultAccountProfileMappingImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.DefaultAccountProfileMappingRequestImpl",
      "DefaultAccountProfileMappingRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.DetailedOrderStatusRequestImpl",
      "DetailedOrderStatusRequestImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.event.admin.EnumTupleImpl", "EnumTupleImpl");
    this.javaToJavaScriptType.set("com.bcdfx.broker.ErrorsImpl", "ErrorsImpl");
    this.javaToJavaScriptType.set("com.bcdfx.model.ExpiryDetailsImpl", "ExpiryDetailsImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.FillLockRequestImpl",
      "FillLockRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.FillNowLockRequestImpl",
      "FillNowLockRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.FillNowLockResponseImpl",
      "FillNowLockResponseImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.fx.FixingDataImpl",
      "FixingDataImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.fx.FixingEventImpl",
      "FixingEventImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.FixingOrderCancellationRequestImpl",
      "FixingOrderCancellationRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.FixingOrderModificationRequestImpl",
      "FixingOrderModificationRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.FixingOrderRequestDataImpl",
      "FixingOrderRequestDataImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.FixingOrderRequestImpl",
      "FixingOrderRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.FixingOrderStatusRequestImpl",
      "FixingOrderStatusRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.FixingOrderUpdateEventImpl",
      "FixingOrderUpdateEventImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.FixingPositionStatusImpl",
      "FixingPositionStatusImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.FixingPriceEventLockResponseImpl",
      "FixingPriceEventLockResponseImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.FixingPriceRequestImpl",
      "FixingPriceRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.FixingRateRequirementDataImpl",
      "FixingRateRequirementDataImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.FixingRateRequirementLockRequestImpl",
      "FixingRateRequirementLockRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.FixingRateRequirementUnlockRequestImpl",
      "FixingRateRequirementUnlockRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.FixingStatusRequestImpl",
      "FixingStatusRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.FixingStatusResponseImpl",
      "FixingStatusResponseImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.FixingSummariesRequestImpl",
      "FixingSummariesRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.fx.ForwardDetailsImpl",
      "ForwardDetailsImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.fwdroll.FwdRollChangeImpl", "FwdRollChangeImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.FwdRollChangeRequestImpl",
      "FwdRollChangeRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.fwdroll.FwdRollChangeResponseImpl",
      "FwdRollChangeResponseImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.fwdroll.FwdRollCurrencyNetPricingImpl",
      "FwdRollCurrencyNetPricingImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.fwdroll.FwdRollDealtPairNetPricingImpl",
      "FwdRollDealtPairNetPricingImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.fwdroll.FwdRollOrderAllocationPricingImpl",
      "FwdRollOrderAllocationPricingImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.fwdroll.FwdRollOrderDataImpl",
      "FwdRollOrderDataImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.fwdroll.FwdRollPricingDataImpl",
      "FwdRollPricingDataImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.fwdroll.FwdRollPricingDataUpdate",
      "FwdRollPricingDataUpdate",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.FwdRollSaveRequestImpl",
      "FwdRollSaveRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.GammaOrderLifeCycleEventImpl",
      "GammaOrderLifeCycleEventImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.HeartBeatImpl", "HeartBeatImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.calendar.HolidayCalendarRequestImpl",
      "HolidayCalendarRequestImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.calendar.HolidayImpl", "HolidayImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.InflightCheckEventImpl",
      "InflightCheckEventImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.InflightCheckStateEventImpl",
      "InflightCheckStateEventImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.InterventionEventImpl", "InterventionEventImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.InterventionQueryRequestImpl",
      "InterventionQueryRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.fx.LastFillDetailsImpl",
      "LastFillDetailsImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.LifeCycleEventResponseImpl",
      "LifeCycleEventResponseImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.LinkedOrderInfoModificationRequestImpl",
      "LinkedOrderInfoModificationRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.LockForFwdRollRequestImpl",
      "LockForFwdRollRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.LockLifeCycleEventImpl",
      "LockLifeCycleEventImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.event.LogonRequestImpl", "LogonRequestImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.ManualNettingBulkEventImpl",
      "ManualNettingBulkEventImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.ManualNettingEventImpl",
      "ManualNettingEventImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.ManualNettingRequestImpl",
      "ManualNettingRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.ManualNettingResponseImpl",
      "ManualNettingResponseImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.ManualPositionHedgingStatusRequestImpl",
      "ManualPositionHedgingStatusRequestImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.event.ManualPriceImpl", "ManualPriceImpl");
    this.javaToJavaScriptType.set("com.bcdfx.streaming.MarketDataEventImpl", "MarketDataEventImpl");
    this.javaToJavaScriptType.set("com.bcdfx.model.MarketDataRequestImpl", "MarketDataRequestImpl");
    this.javaToJavaScriptType.set("com.bcdfx.streaming.MarketRateImpl", "MarketRateImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.MarketTimeConstantImpl",
      "MarketTimeConstantImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.MarkupInfoImpl", "MarkupInfoImpl");
    this.javaToJavaScriptType.set("com.bcdfx.model.event.ModelUpdateImpl", "ModelUpdateImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.ModificationLockRequestImpl",
      "ModificationLockRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.NdfFixingDateLookupRequestImpl",
      "NdfFixingDateLookupRequestImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.NdfSourceImpl", "NdfSourceImpl");
    this.javaToJavaScriptType.set("com.bcdfx.model.event.NettingPairImpl", "NettingPairImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.OpsExcClearingDataImpl",
      "OpsExcClearingDataImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.OpsExcInfoImpl", "OpsExcInfoImpl");
    this.javaToJavaScriptType.set("com.bcdfx.model.OpsExcRecordImpl", "OpsExcRecordImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.OpsExceptionActionRequestImpl",
      "OpsExceptionActionRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.OpsExceptionRequestImpl",
      "OpsExceptionRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.opsfilters.OpsFiltCategoryImpl",
      "OpsFiltCategoryImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.opsfilters.OpsFiltCategoryTypeImpl",
      "OpsFiltCategoryTypeImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.OpsFilterCategoryRequestImpl",
      "OpsFilterCategoryRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.opsfilters.OpsFilterCompositeDataImpl",
      "OpsFilterCompositeDataImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.OpsIntEventImpl", "OpsIntEventImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.OrderAcceptanceRequestImpl",
      "OrderAcceptanceRequestImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.audit.OrderAuditImpl", "OrderAuditImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.OrderAuditLookupRequestImpl",
      "OrderAuditLookupRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.OrderCancellationRequestImpl",
      "OrderCancellationRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.OrderCancellationSingleRequestImpl",
      "OrderCancellationSingleRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.OrderDeleteRequestImpl",
      "OrderDeleteRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.OrderExportRequestImpl",
      "OrderExportRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.OrderExportResponseImpl",
      "OrderExportResponseImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.OrderFillDataImpl",
      "OrderFillDataImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.OrderFillNowRequestImpl",
      "OrderFillNowRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.OrderFillNowResponseImpl",
      "OrderFillNowResponseImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.OrderFillRequestImpl",
      "OrderFillRequestImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.service.OrderFillResultImpl", "OrderFillResultImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.admin.AdminImportStatusEventImpl",
      "AdminImportStatusEventImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.admin.AdminImportStatusInfoImpl",
      "AdminImportStatusInfoImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.admin.AdminModelUploadImpl",
      "AdminModelUploadImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.admin.AdminModelUploadErrorImpl",
      "AdminModelUploadErrorImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.OrderImportRequestImpl",
      "OrderImportRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.OrderLifeCycleEventImpl",
      "OrderLifeCycleEventImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.monitor.api.OrderMonitorClusterMessage",
      "OrderMonitorClusterMessage",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.OrderPTPCompositeImpl",
      "OrderPTPCompositeImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.OrderPauseResumeRequestImpl",
      "OrderPauseResumeRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.OrderPauseResumeResponseImpl",
      "OrderPauseResumeResponseImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.OrderQueryRequestImpl",
      "OrderQueryRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.OrderReactivationRequestImpl",
      "OrderReactivationRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.service.OrderReactivationResultImpl",
      "OrderReactivationResultImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.OrderRecapLookupRequestImpl",
      "OrderRecapLookupRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.OrderSalesApprovalRequestImpl",
      "OrderSalesApprovalRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.OrderStatusRequestImpl",
      "OrderStatusRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.OrderTransferRequestImpl",
      "OrderTransferRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.service.OrderTransferResultImpl",
      "OrderTransferResultImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.event.OrderUpdateImpl", "OrderUpdateImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.PasswordChangeRequestImpl",
      "PasswordChangeRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.PauseLifeCycleEventImpl",
      "PauseLifeCycleEventImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.PauseOrderDataImpl",
      "PauseOrderDataImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.event.PingTimerImpl", "PingTimerImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.PlRequestOrderTypeStrategyImpl",
      "PlRequestOrderTypeStrategyImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.PlatformOrderQueryRequestImpl",
      "PlatformOrderQueryRequestImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.PlatformProfileImpl", "PlatformProfileImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.PortfolioClearForwardPriceRequestImpl",
      "PortfolioClearForwardPriceRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.PortfolioForwardPriceRequestImpl",
      "PortfolioForwardPriceRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.service.PortfolioForwardPriceResultImpl",
      "PortfolioForwardPriceResultImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.PortfolioRetryForwardPriceRequestImpl",
      "PortfolioRetryForwardPriceRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.PositionBookFetchResponseImpl",
      "PositionBookFetchResponseImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.PositionBookFilterMatchRequestImpl",
      "PositionBookFilterMatchRequestImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.PositionBookImpl", "PositionBookImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.PositionBookPairInfoImpl",
      "PositionBookPairInfoImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.PositionBookRequestImpl",
      "PositionBookRequestImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.PrivilegeGroupImpl", "PrivilegeGroupImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.service.messaging.impl.ProducerChannelImpl",
      "ProducerChannelImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.ProfileSettingImpl", "ProfileSettingImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.ProfileUpdateRequestImpl",
      "ProfileUpdateRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.PublicProfileUpdateRequestImpl",
      "PublicProfileUpdateRequestImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.broker.SessionMetadataImpl", "SessionMetadataImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.broker.SessionInvalidationImpl",
      "SessionInvalidationImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.query.QueryGroupImpl", "QueryGroupImpl");
    this.javaToJavaScriptType.set("com.bcdfx.model.query.QueryRuleImpl", "QueryRuleImpl");
    this.javaToJavaScriptType.set("com.bcdfx.model.query.QuerySortEntryImpl", "QuerySortEntryImpl");
    this.javaToJavaScriptType.set("com.bcdfx.model.query.QuerySortImpl", "QuerySortImpl");
    this.javaToJavaScriptType.set("com.bcdfx.model.event.lifecycle.RateDataImpl", "RateDataImpl");
    this.javaToJavaScriptType.set("com.bcdfx.model.RateSourceImpl", "RateSourceImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.sysmon.impl.RemoteTelemetryUpdateRequestImpl",
      "RemoteTelemetryUpdateRequestImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.security.SSOToken", "SSOToken");
    this.javaToJavaScriptType.set("com.bcdfx.stp.bridge.STPAcknowledgement", "STPAcknowledgement");
    this.javaToJavaScriptType.set("com.bcdfx.stp.bridge.STPMessage", "STPMessage");
    this.javaToJavaScriptType.set("com.bcdfx.model.SalesGroupImpl", "SalesGroupImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.SavedOrderEventImpl",
      "SavedOrderEventImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.SavedOrderEventListImpl",
      "SavedOrderEventListImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.SavedProfileRequestImpl",
      "SavedProfileRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.SecureTokenRefreshRequestImpl",
      "SecureTokenRefreshRequestImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.broker.ServiceRequestError", "ServiceRequestError");
    this.javaToJavaScriptType.set(
      "com.bcdfx.service.impl.ServiceResponseImpl",
      "ServiceResponseImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.session.SessionDisconnectRequestImpl",
      "SessionDisconnectRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.SessionInitialiserReponseImpl",
      "SessionInitialiserReponseImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.servicerequest.impl.SessionInitialiserRequestImpl",
      "SessionInitialiserRequestImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.SessionPurgeEventImpl", "SessionPurgeEventImpl");
    this.javaToJavaScriptType.set("com.bcdfx.model.StandardDateImpl", "StandardDateImpl");
    this.javaToJavaScriptType.set("com.bcdfx.service.StandardReportImpl", "StandardReportImpl");
    this.javaToJavaScriptType.set("com.bcdfx.model.StandardTimeImpl", "StandardTimeImpl");
    this.javaToJavaScriptType.set("com.bcdfx.model.StaticDataProfileImpl", "StaticDataProfileImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.StaticDataProfileRequestImpl",
      "StaticDataProfileRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.StrategyAmendModificationLockResponseImpl",
      "StrategyAmendModificationLockResponseImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.StrategyComponentStateImpl",
      "StrategyComponentStateImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.StrategyFillLockResponseImpl",
      "StrategyFillLockResponseImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.StrategyModificationLockResponseImpl",
      "StrategyModificationLockResponseImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.StrategyParameterImpl",
      "StrategyParameterImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.fx.SuspensionDetailsImpl",
      "SuspensionDetailsImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.fx.SwapDetailsImpl",
      "SwapDetailsImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.SysCtrlEventImpl", "SysCtrlEventImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.SysTradeDateRolloverEventImpl",
      "SysTradeDateRolloverEventImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.SystemControlImpl", "SystemControlImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.SystemControlUpdateRequestImpl",
      "SystemControlUpdateRequestImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.SystemMessageImpl", "SystemMessageImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.sysmon.impl.SystemMonitorEventImpl",
      "SystemMonitorEventImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.sysmon.impl.SystemMonitorEventSetImpl",
      "SystemMonitorEventSetImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.SystemMonitorHistoryRequestImpl",
      "SystemMonitorHistoryRequestImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.SystemSettingImpl", "SystemSettingImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.sysmon.impl.TelemetryCatalogueEntryImpl",
      "TelemetryCatalogueEntryImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.sysmon.impl.TelemetrySubscriptionCatalogueImpl",
      "TelemetrySubscriptionCatalogueImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.sysmon.impl.TelemetrySubscriptionCatalogueRequestImpl",
      "TelemetrySubscriptionCatalogueRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.sysmon.impl.TelemetrySubscriptionRequestImpl",
      "TelemetrySubscriptionRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.module.tenor2date.announcer.TenorToDateEventResponse",
      "TenorToDateEventResponse",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.calendar.TenorToValueAndFixingDateImpl",
      "TenorToValueAndFixingDateImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.calendar.TenorToValueDateImpl",
      "TenorToValueDateImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.TerminateUserSessionRequestImpl",
      "TerminateUserSessionRequestImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.TestEntity", "TestEntity");
    this.javaToJavaScriptType.set("com.bcdfx.service.messaging.impl.TestObject", "TestObject");
    this.javaToJavaScriptType.set("com.bcdfx.model.TimeImpl", "TimeImpl");
    this.javaToJavaScriptType.set("com.bcdfx.model.calendar.TimeZoneImpl", "TimeZoneImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.ToggleInflightStateRequestImpl",
      "ToggleInflightStateRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.ToggleInflightStateResultImpl",
      "ToggleInflightStateResultImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.ToggleInflightStateResultItemImpl",
      "ToggleInflightStateResultItemImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.TradeActionRequestImpl",
      "TradeActionRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.TradeQueryRequestImpl",
      "TradeQueryRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.TradeStatusRequestImpl",
      "TradeStatusRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.TradingCalendarRequestImpl",
      "TradingCalendarRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.calendar.TradingCalendarRunImpl",
      "TradingCalendarRunImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.calendar.TradingCalendarSnapShotImpl",
      "TradingCalendarSnapShotImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.TradingChannelProfileImpl",
      "TradingChannelProfileImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.TradingGroupImpl", "TradingGroupImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.fx.TrailingStopDetailsImpl",
      "TrailingStopDetailsImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.TrailingStopEventImpl",
      "TrailingStopEventImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.fx.TriggerDetailsImpl",
      "TriggerDetailsImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.security.TrustToken", "TrustToken");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.UnlockFwdRollRequestImpl",
      "UnlockFwdRollRequestImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.event.UnlockRequestImpl", "UnlockRequestImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.UnsolicitedCancelLifeCycleEventImpl",
      "UnsolicitedCancelLifeCycleEventImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.UpdateClientCommentsRequestImpl",
      "UpdateClientCommentsRequestImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.UserClientMemberImpl", "UserClientMemberImpl");
    this.javaToJavaScriptType.set("com.bcdfx.model.UserImpl", "UserImpl");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.UserProfileChangeEventImpl",
      "UserProfileChangeEventImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.UserProfileChangeRequestImpl",
      "UserProfileChangeRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.UserVisibilityProfileImpl",
      "UserVisibilityProfileImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.UserVisibilityRuleImpl",
      "UserVisibilityRuleImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.VisbilityProfileChangeEventImpl",
      "VisbilityProfileChangeEventImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.VisibilityProfileImpl", "VisibilityProfileImpl");
    this.javaToJavaScriptType.set("com.bcdfx.service.WebTierFeedEvent", "WebTierFeedEvent");
    this.javaToJavaScriptType.set("com.bcdfx.model.event.lifecycle.XferEventImpl", "XferEventImpl");
    this.javaToJavaScriptType.set("com.bcdfx.model.event.lifecycle.XferInfoImpl", "XferInfoImpl");

    // any non-encodeable type only used in handwritten encoders must list mapping here
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.LinkedOrderModificationRequestImpl",
      "LinkedOrderModificationRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.LinkedOrderRequestImpl",
      "LinkedOrderRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.fx.OrderDataImpl",
      "OrderDataImpl",
    );
    this.javaToJavaScriptType.set("com.bcdfx.model.Relationship", "Relationship");
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.LinkedRelationshipImpl",
      "LinkedRelationshipImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.OrderRequestDataImpl",
      "OrderRequestDataImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.GammaOrderRequestImpl",
      "GammaOrderRequestImpl",
    );
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.ChangeHedgingModeEventImpl",
      "ChangeHedgingModeEventImpl",
    );

    // override broken autogenerated type (missing encoder)
    this.javaToJavaScriptType.set(
      "com.bcdfx.model.event.lifecycle.RelationshipImpl",
      "Relationship",
    );

    //error mapping
    this.javaToJavaScriptType.set("com.bcdfx.model.Errors", "ErrorsImpl");

    // static enum
    this.javaToTypeScriptEnum.set(
      "com.bcdfx.api.model.OrderRelationshipType",
      "OrderRelationshipType",
    );
    this.javaToTypeScriptEnum.set("com.bcdfx.model.FillState", "FillState");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.FillSupport", "FillSupport");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.LockType", "LockType");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.OrderExpiryType", "OrderExpiryType");
    this.javaToTypeScriptEnum.set(
      "com.bcdfx.model.RequestorFillTypeRestriction",
      "RequestorFillTypeRestriction",
    );
    this.javaToTypeScriptEnum.set("com.bcdfx.model.RequestTrackingType", "RequestTrackingType");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.MarkUpType", "MarkUpType");
    this.javaToTypeScriptEnum.set("com.bcdfx.model.HedgingModeType", "HedgingModeType");
  }

  public resolveEnum(javaType: string): string | undefined {
    if (!this.javaToTypeScriptEnum.get(javaType)) {
      logger.out.error(`CubiqResolver.resolveEnum() failed to resolve ${javaType}`);
    }
    return this.javaToTypeScriptEnum.get(javaType);
  }
  public resolveObject(javaType: string): string | undefined {
    if (!this.javaToJavaScriptType.get(javaType) && !this.encodedTypes.has(javaType)) {
      logger.out.error(`CubiqResolver.resolveObject() failed to resolve ${javaType}`);
    }

    return this.javaToJavaScriptType.get(javaType);
  }

  public resolveObjectEncoder(javaType: string): string | undefined {
    let objectType = this.javaToJavaScriptType.get(javaType);

    if (objectType) {
      return objectType + "Encoder";
    } else {
      logger.out.error(
        `CubiqResolver.resolveObjectEncoder() failed to resolve encoder for ${javaType}`,
      );
    }
  }
  public toString(): string {
    return "Map[" + this.javaToJavaScriptType + "]";
  }
  public isString(cls: string): boolean {
    return cls === "java.lang.String";
  }
  public isByteBuffer(cls: string): boolean {
    return cls === "java.nio.ByteBuffer";
  }
  public isDate(cls: string): boolean {
    return cls === "java.util.Calendar" || cls === "java.util.Date";
  }
  public isBoolean(cls: string): boolean {
    return cls === "java.lang.Boolean" || cls === "boolean";
  }
  public isLong(cls: string): boolean {
    return cls === "java.lang.Long" || cls === "java.lang.Number" || cls === "long";
  }
  public isInteger(cls: string): boolean {
    return cls === "java.lang.Integer" || cls === "int" || cls === "short";
  }
  public isDecimalNumber(cls: string): boolean {
    return cls === "java.math.BigDecimal";
  }
  public isDouble(cls: string): boolean {
    return (
      cls === "java.lang.Double" || cls === "double" || cls === "java.lang.Float" || cls === "float"
    );
  }
  public isMap(cls: string): boolean {
    return cls === "java.util.Map";
  }
  public isEnum(cls: string): boolean {
    return this.javaToTypeScriptEnum.has(cls);
  }
  public isEncodableType(cls: string): boolean {
    let isEncodableType = this.javaToJavaScriptType.has(cls);

    if (!isEncodableType) {
      if (this.isUnknownType(cls)) {
        // e.g. readList/writeList
        logger.out.error(`CubiqResolver.isEncodableType() unknown type ${cls}`);
      }
    }

    return isEncodableType;
  }
  private isUnknownType(cls: string): boolean {
    return !(
      this.encodedTypes.has(cls) ||
      this.javaToTypeScriptEnum.has(cls) ||
      this.javaToJavaScriptType.has(cls)
    );
  }
}
